import { Auth0Client, User } from '@auth0/auth0-spa-js';

// Auth0 configuration - these should match your Auth0 application settings
export const auth0Config = {
    domain: 'auth0.allenai.org',
    clientId: 'B5Si5eqSWxd6KTumBBZ0Eh9c97jNf9kp',
    audience: 'https://asta-core.allen.ai',
};

export const auth0Client =
    typeof window !== 'undefined'
        ? new Auth0Client({
              domain: auth0Config.domain,
              clientId: auth0Config.clientId,
              cacheLocation: 'localstorage',
              useRefreshTokens: true,
              authorizationParams: {
                  redirect_uri: window.location.origin,
                  audience: auth0Config.audience,
                  scope: 'openid profile email offline_access',
              },
          })
        : null;

/**
 * Check if the user is authenticated
 */
export async function isAuthenticated(): Promise<boolean> {
    if (!auth0Client) {
        return false;
    }
    return await auth0Client.isAuthenticated();
}

/**
 * Get the authenticated user's profile
 */
export async function getUser(): Promise<User | undefined> {
    if (!auth0Client) {
        return undefined;
    }
    return await auth0Client.getUser();
}

/**
 * Get the user's email if authenticated, otherwise return null
 */
export async function getUserEmail(): Promise<string | null> {
    const user = await getUser();
    return user?.email || null;
}
